<ng-select #docField [items]="field?.meta_data?.meta_data_option" [clearable]="false" bindLabel="name" bindValue="value"
     [ngModel]="value" (change)="updateDroplistValue($event)" placeholder="Select option"></ng-select>